<template>
  <div class="review-extra-service-component">
    <item name="Serviços Complementares" :price="formatPrice(totalPrice)" v-if="totalPrice > 0"></item>
    <div
      v-for="(extraService, index) in formData.extraServices.data"
      :key="index"
      class="px-6"
    >
      <sub-item
        v-if="extraService.quantity && extraService.quantity > 0"
        :name="extraService.name"
        :price="formatPrice(parseExtraServicePrice(extraService))"
      ></sub-item>
    </div>
    <item name="Implantação" hidePrice/>
    <item name="Valor" class="itemBold" :price="formatPrice(formData.plan.data.setup_price)" />
  </div>
</template>

<script>

import Item from './Item'
import SubItem from './SubItem'

export default {

  name: 'review-extra-services',

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  components: {
    Item,
    SubItem
  },

  data() {
    return {
      totalPrice: 0
    }
  },

  watch: {
    'formData.extraServices.data': {
      handler() {
        this.calculateTotalPrice()
      },
      deep: true
    }
  },

  mounted() {
    this.calculateTotalPrice()
  },

  methods: {
    parseExtraServicePrice(extraService) {
      return parseFloat(extraService.price) * extraService.quantity
    },
    formatPrice(value) {
      return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
          .replace('R$', '').trim();
    },
    calculateTotalPrice() {
      let total = 0
      for (const extraService of this.formData.extraServices.data) {
        total += this.parseExtraServicePrice(extraService)
      }
      this.totalPrice = total
    }
  }

}

</script>

<style>
  .itemBold .has-text-weight-bold  {
    color: #2C2C2C !important;
  }
</style>